import { render, staticRenderFns } from "./priorityList.vue?vue&type=template&id=ccf4955c&"
import script from "./priorityList.vue?vue&type=script&lang=js&"
export * from "./priorityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports